/**
 * @prettier
 */
import {createSelector} from 'reselect';
import {getTranslations} from './store';
import {getLocale} from './system';
import {getSearchUrl, getSearchBaseUrl} from './searchUrl';
import {getListingRecommendedProperties} from './listing';
import {currencyFormatter} from '@homeaway/hacommons-i18n';

const fillHitLabels = (listingRecommendedProperties, translations, locale) => {
    return (
        listingRecommendedProperties.recommendedHits &&
        listingRecommendedProperties.recommendedHits.map((hit) => {
            const averageNightly =
                hit.price &&
                currencyFormatter.formatNumber({
                    value: hit.price.averageNightly,
                    currencyCode: hit.price.currencyUnits,
                    locale
                });
            const bedroomsLabel =
                hit.bedrooms === 0
                    ? translations.studio
                    : `${hit.bedrooms}${translations.bedroomsAbbreviation}`;
            hit.cardTitle = `${bedroomsLabel} · ${translations.sleeps} ${hit.sleeps}`;
            hit.ratesLabel = averageNightly
                ? `${averageNightly} ${translations.averageNightly}`
                : '';
            return hit;
        })
    );
};

const getRecommendedProperties = createSelector(
    [getTranslations, getListingRecommendedProperties, getLocale, getSearchUrl, getSearchBaseUrl],
    (translations, listingRecommendedProperties, locale, searchUrl, searchUrlBase) => {
        if (listingRecommendedProperties) {
            listingRecommendedProperties.recommendedHits = fillHitLabels(
                listingRecommendedProperties,
                translations,
                locale
            );
        }
        return {
            ...listingRecommendedProperties,
            translations: {
                recommendationMessage: translations.recommendationMessage,
                rpNoReviews: translations.rpNoReviews,
                sleeps: translations.sleeps,
                bedroomsAbbreviation: translations.bedroomsAbbreviation,
                averageNightly: translations.averageNightly,
                seeMore: translations.seeMore,
                studio: translations.studio
            },
            searchUrl,
            searchUrlBase,
            locale
        };
    }
);

export default getRecommendedProperties;

export {getRecommendedProperties, fillHitLabels};
